import {
  ColorClass,
  Icon,
  IconIdentifier,
  Placement,
  Tooltip,
  UploadStatus,
} from '@aus-platform/design-system';
import { isEmpty } from 'lodash';
import type React from 'react';
import type { FileDetails } from 'shared/upload-widget-slices/types';
import { uploadStatusesWithoutPlaybackAction } from './constants';

type UploadWidgetItemActionsProps = {
  uploadStatus: UploadStatus;
  fileDetails?: FileDetails;
  onCancel: VoidFunction;
  onPause: VoidFunction;
  onResume: VoidFunction;
};

export const UploadWidgetItemActions: React.FC<
  UploadWidgetItemActionsProps
> = ({ uploadStatus, fileDetails, onCancel, onPause, onResume }) => {
  const { projectName, siteName, iterationName } = fileDetails ?? {};

  const hasFileDetails =
    !isEmpty(projectName) || !isEmpty(siteName) || !isEmpty(iterationName);
  const hasPlaybackAction =
    !uploadStatusesWithoutPlaybackAction.includes(uploadStatus);
  const isPaused = uploadStatus === UploadStatus.Paused;

  return (
    <div className="upload-widget-list-item__actions">
      <Icon
        className="upload-widget-list-item__actions-cancel"
        identifier={IconIdentifier.CloseCircle}
        colorClass={ColorClass.AccentError}
        size={20}
        onClick={onCancel}
      />
      {hasPlaybackAction && isPaused && (
        <Icon
          className="upload-widget-list-item__actions-play"
          identifier={IconIdentifier.PlayCircle}
          colorClass={ColorClass.Primary500}
          size={20}
          onClick={onResume}
        />
      )}
      {hasPlaybackAction && !isPaused && (
        <Icon
          className="upload-widget-list-item__actions-pause"
          identifier={IconIdentifier.PauseCircle}
          colorClass={ColorClass.Primary500}
          size={20}
          onClick={onPause}
        />
      )}
      {hasFileDetails && (
        <Tooltip
          hoverText={
            <>
              {!isEmpty(projectName) && (
                <div className="tooltip-row">
                  <span className="tooltip-label">Project</span>
                  <span className="tooltip-value">{projectName}</span>
                </div>
              )}

              {!isEmpty(siteName) && (
                <div className="tooltip-row">
                  <span className="tooltip-label">Site</span>
                  <span className="tooltip-value">{siteName}</span>
                </div>
              )}

              {!isEmpty(iterationName) && (
                <div className="tooltip-row">
                  <span className="tooltip-label">Iteration</span>
                  <span className="tooltip-value">{iterationName}</span>
                </div>
              )}
            </>
          }
          placement={Placement.TopEnd}
          className="upload-widget-list-item__actions-tooltip"
        >
          <Icon
            className="upload-widget-list-item__actions-info"
            identifier={IconIdentifier.InfoCircle}
            colorClass={ColorClass.Primary500}
            size={20}
          />
        </Tooltip>
      )}
    </div>
  );
};
